<template>
  <div class="404">
    <div class="middle-box text-center loginscreen animated fadeInDown">
      <div>
        <div>
          <img style="margin-bottom: 50px;" src="/static/logo-my-emateriel.svg" />
        </div>
        <h3>Page non trouvée</h3>
        <p>
          <router-link :to="{name: 'Home'}">Retourner au Dashboard</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorNotFound",
  created: function() {
    // Redirect using plain old javascript
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Global/ErrorNotFound.vue